import { Content } from '../../types';

export const kampongPlukContent: Content = {
  title: 'קמפונג פלוק Kampong Pluk – הכפר הצף המרכזי של קמבודיה',
  imageUrl: 'https://tinyurl.com/kampong-pluk-wide',
  introduction: `קמפונג פלוק הוא כפר ייחודי השוכן במחוז סיאם ריפ, על חופו של אגם טונלה סאפ, במרחק של כשעה נסיעה מהעיר סיאם ריפ. הכפר מתאפיין בסגנון חיים יוצא דופן, המושפע במידה רבה מתנאי הסביבה המשתנים של האגם.`,
  sections: [
    {
      title: 'סגנון הבנייה הייחודי של הכפר',
      content: `המראה המאפיין ביותר של קמפונג פלוק הוא הבתים הבנויים על כלונסאות עץ גבוהות ודקות, המותאמות לשינויים הדרמטיים במפלס המים לאורך השנה. במהלך העונה הגשומה, כאשר האגם מתמלא, הבתים נראים כאילו הם צפים על פני המים. מנגד, בעונה היבשה, כאשר מפלס המים יורד משמעותית, נחשפים עמודי העץ הגבוהים, והכפר נראה כעיר על קביים. המבנים עשויים בעיקר מעץ, אם כי ניתן למצוא גם שימוש בחומרים נוספים.`,
      type: 'text',
    },
    {
      title: 'אורח החיים של תושבי הכפר',
      content: `הכפר משמר מסורות ואורח חיים שנות דור מאחור, מה שהופך את הביקור בו לחוויה תרבותית אותנטית. תושבי הכפר מתפרנסים בעיקר מדיג, שהוא מקור הפרנסה העיקרי בתקופות בהן האגם מלא. עם זאת, בעונה היבשה, בין נובמבר לאפריל, כשהמים נסוגים והדיג הופך למאתגר יותר, פונים המקומיים לעיסוקי חקלאות, בעיקר בגידול ירקות וגידולים מותאמים לאדמות הבוציות שנותרות חשופות.`,
      type: 'text',
    },
    {
      title: 'התפתחות התיירות בקמפונג פלוק',
      content: `בשנים האחרונות חלה התפתחות משמעותית בענף התיירות בכפר, כאשר תושביו זיהו את הפוטנציאל הגלום בסגנון חייהם הייחודי. כיום, תיירים רבים מגיעים לקמפונג פלוק כדי לחוות את חיי היומיום של המקומיים ולהתרשם מהאווירה הייחודית של המקום. הסיורים בכפר כוללים שייט לאורך תעלות המים החוצות את בתי הכפר ומתן הזדמנות להתבונן מקרוב בסגנון החיים המסורתי של התושבים. הביקור לרוב מסתיים בצפייה בשקיעה עוצרת נשימה מעל אגם טונלה סאפ – חוויה מומלצת במיוחד!`,
      type: 'text',
    },
    {
      title: 'טיפים לביקור בכפר',
      content: [
        'מתי להגיע? העונה הרטובה (מאי–אוקטובר) מציעה חוויה מרהיבה של בתים "צפים" ומאפשרת שייט נוח בכפר. בעונה היבשה (נובמבר–אפריל) נחשפים עמודי הכלונסאות, והכפר מקבל מראה אחר לחלוטין.',
        'כיצד להגיע? ניתן להגיע לקמפונג פלוק באמצעות מונית פרטית/ טוקטוק או טיולים מאורגנים היוצאים מסיאם ריפ.',
        'מחיר הסיור: השייט בכפר הוא בתשלום, ויש לקחת בחשבון מחירים משתנים בהתאם לעונה ולמסלול הנבחר.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `קמפונג פלוק הוא יעד חובה למבקרים באזור סיאם ריפ והוא מציע הצצה נדירה לחיים בכפרים הצפים של קמבודיה. חוויית השייט, יחד עם הנופים הקסומים ואורח החיים המסורתי, הופכים את הביקור בו לבלתי נשכח.`,
      type: 'text',
    },
  ],
};
